import React, { useState } from "react";
import { BgQuestionMark } from "../utils/icons";
import ColepsableBackground from "../assets/images/ColepsableBackground.png";
import needHelpImg from "../assets/images/needHelpImg.png";
import { SIGNUP_FORM_BASIC } from "../utils/constant";
import FormItem from "antd/es/form/FormItem";
import CurrentInput from "./CurrentInput/CurrentInput";
import { Button, Form } from "antd";
import { uploadImageArray } from "../utils/utils";
import { BugReportsSlice } from "../slices/userSlice";
import { useDispatch } from "react-redux";
import toastMessage from "../utils/toastMessage";
import MyModal from "./CustomModal/Modal";
import GradientButton from "./Button/GradientButton";

const NeedHelp = () => {
  const [open, setOpen] = React.useState(false);
  const [formGenerationInfo, setFormGenerationInfo] = useState(
    SIGNUP_FORM_BASIC["BUGS_UPDATED_MODAL"]
  );
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const handleCancel = () => {
    setOpen(false);
  };

  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState();
  const [imagesArray, setImagesArray] = useState();

  const handleChangeInput = (val, name) => {
    setUserData((prev) => ({
      ...prev,
      [name]: val,
    }));

    console.log(val, name, "asndajasnjsaval, name");
    form.setFieldsValue({ [name]: val });
  };

  console.log({ userData });

  const handleSave = async (values) => {
    console.log({ userData });
    if (!userData.Title) {
      toastMessage("Title is required", "error");
      return;
    }
    setLoading(true);
    const ImageUrl = await uploadImageArray(userData.ImageUrl);
    console.log({ ...userData, ImageUrl }, "asnknancnasjcjascascjasnasjascn");
    dispatch(BugReportsSlice({ ...userData, ImageUrl }))
      .unwrap()
      .then((res) => {
        console.log(res.data, "=res:updateEducationalInfo");
        toastMessage(res.message, "success");
        setOpen(false);
        setUserData({});
      })
      .catch((err) => {
        console.log(err, "=err:updateEducationalInfo");
        setOpen(false);
      })
      .finally(() => {
        setOpen(false);
        setLoading(false);
      });
  };
  return (
    <div
      className="p-5 rounded-lg flex flex-col gap-5 bg-no-repeat bg-cover items-center"
      style={{
        backgroundImage: `url(${needHelpImg})`,
      }}
    >
      <BgQuestionMark />
      <div className="text-center">
        <p
          className="text-white font-bold cursor-pointer hover:underline"
          onClick={() => setOpen(true)}
        >
          Need help?
        </p>
        <p
          // className="text-white text-sm md:text-base lg:text-lg"
          className="text-white text-xs"
        >
          Please check our documents for assistance or chat with us.
        </p>
      </div>
      <GradientButton
        className="text-xs w-[130px]"
        // className="bg-slate-50 rounded-lg px-4 py-2 text-sm md:text-sm lg:text-sm font-bold"
      >
        DOCUMENTATION
      </GradientButton>
      {open && (
        <MyModal
          className="addEventStyle"
          width={"400px"}
          footer={false}
          title={
            <div className="flex flex-col">
              <p className="text-xl text-DarkGrey">Need Help?</p>
              <p className="text-sm text-DarkGrey">
                Need any queries please update here.
              </p>
            </div>
          }
          open={open}
          onOk={handleSave}
          onCancel={() => {
            setOpen(false);
            setUserData({});
          }}
          maskClosable={false}
        >
          {formGenerationInfo?.map((info, index) => {
            console.log(info, "informationnnnnnnnnnnnnnnnnnn");
            return (
              <React.Fragment key={index}>
                <div
                  key={index}
                  className="pb-2 w-full flex flex-col items-center gap-x-8 gap-y-5"
                >
                  {info?.map((data, i) => (
                    <FormItem
                      key={i + "-" + index}
                      className={`w-full px-5 sm:px-0 sm:w-full ${
                        data.type === "Checkbox" ? "lg:w-full" : ""
                      } ${data.className}`}
                      name={data.name + index}
                      rules={data.rules}
                      // dependencies={data?.dependencies}
                    >
                      <p className="text-gray-500 mt-[-4px] pl-1">
                        {data.label}
                      </p>
                      <CurrentInput
                        data={{ ...data, name: data.name, index }}
                        onChange={handleChangeInput}
                        formInputData={userData}
                        indexNum={index}
                        // beforeUpload={beforeUpload}
                        value={userData[data.name + index]}
                      />
                    </FormItem>
                  ))}
                  <div className="flex justify-center gap-5">
                    <Button
                      loading={loading}
                      onClick={handleSave}
                      className="text-pureWhite rounded-3xl bg-sandAgainBtn border-none w-[100px] hover:text-black"
                    >
                      Save
                    </Button>
                    <Button
                      onClick={() => {
                        setUserData({});
                        handleCancel();
                      }}
                      className="text-orange2 rounded-3xl border-orange2 w-[100px] hover:text-black "
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </MyModal>
      )}
    </div>
  );
};

export default NeedHelp;
